<template>
  <div>
    <status-badge
      v-if="!settlement.status.settlementObjectCount"
    >
      {{ trans('settlement.statusOpen') }}
    </status-badge>
    <status-badge
      v-else-if="settlement.status.sepaDownloadedCount === settlement.status.sepaDownloadedMax"
      color="success"
    >
      <v-icon left small>mdi-check</v-icon>{{ trans('settlement.statusCompleted') }}
    </status-badge>
    <v-chip
      outlined
      v-else
    >
      <template v-if="settlement.status.checkedCount < settlement.status.checkedMax">
        <settlement-checked-icon left :value="true"/>
        {{settlement.status.checkedCount}}
        <span class="px-1">/</span>
        {{ settlement.status.checkedMax }}
      </template>
      <template v-else-if="settlement.status.sentToOwnerCount < settlement.status.sentToOwnerMax">
        <settlement-owner-email-icon left :value="true"/>
        {{settlement.status.sentToOwnerCount}}
        <span class="px-1">/</span>
        {{ settlement.status.sentToOwnerMax }}
      </template>
      <template v-else-if="settlement.status.datevDownloadedCount < settlement.status.datevDownloadedMax">
        <settlement-datev-downloaded-icon left :value="true"/>
        {{settlement.status.datevDownloadedCount}}
        <span class="px-1">/</span>
        {{ settlement.status.datevDownloadedMax }}
      </template>
      <template v-else>
        <settlement-sepa-downloaded-icon left :value="true"/>
        {{settlement.status.sepaDownloadedCount}}
        <span class="px-1">/</span>
        {{ settlement.status.sepaDownloadedMax }}
      </template>
    </v-chip>
  </div>
</template>
<script>
import SettlementCheckedIcon from '@/components/icons/SettlementCheckedIcon'
import SettlementDatevDownloadedIcon from '@/components/icons/SettlementDatevDownloadIcon'
import SettlementOwnerEmailIcon from '@/components/icons/SettlementOwnerEmailIcon'
import SettlementSepaDownloadedIcon from '@/components/icons/SettlementSepaDownloadIcon'
import StatusBadge from './StatusBadge';
import {LocaleUtils} from './../utils/locale-utils';

export default {
  name: 'SettlementStatus',
  mixins: [
    LocaleUtils
  ],
  components: {
    StatusBadge,
    SettlementCheckedIcon,
    SettlementDatevDownloadedIcon,
    SettlementOwnerEmailIcon,
    SettlementSepaDownloadedIcon
  },
  props: {
    /** @type SettlementDto */
    settlement: {}
  }
}
</script>
